import { useId } from 'react'
import { RefreshCw } from '../../icons/refresh-cw'
import { Button } from '../button/button'

export interface RecoveryStateProps {
  title: string
  description: string
  retryLabel: string
  retryingLabel: string
  retrying: boolean
  onRetry: () => void
}

export function RecoveryState({
  title,
  description,
  retryLabel,
  retryingLabel,
  retrying,
  onRetry,
}: RecoveryStateProps) {
  const titleId = useId()
  return (
    <section className='recovery-state' aria-labelledby={titleId} aria-busy={retrying}>
      <div className='recovery-state__illustration' aria-hidden='true'>
        <svg viewBox='0 0 80 64' fill='none'>
          <circle cx='40' cy='32' r='30' className='recovery-state__halo' />
          <g
            className='recovery-state__cloud'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path
              d='M25 44a10 10 0 0 1-1-20 16 16 0 0 1 30-2 11 11 0 0 1 1 22Z'
              className='recovery-state__cloud-fill'
            />
            <path d='M33 32h1m12 0h1M37 38h6' />
          </g>
        </svg>
      </div>
      <div className='recovery-state__copy' role='status' aria-live='polite'>
        <h2 id={titleId}>{title}</h2>
        <p>{description}</p>
      </div>
      <Button variant='primary' type='button' disabled={retrying} onClick={onRetry}>
        <RefreshCw aria-hidden='true' className={retrying ? 'recovery-state__spin' : undefined} />
        {retrying ? retryingLabel : retryLabel}
      </Button>
    </section>
  )
}
